import { DB } from "firebase-tools/db";
import { ISchedulePost } from "interfaces/ISchedulePost";

export class SchedulePostService extends DB {
  private _doc: string = "";
  private _collection: string = "";

  constructor(collection?: string, doc?: string) {
    super();
    if (doc) {
      this.doc = doc;
    }
    if (collection) {
      this.collection = collection;
    }
  }

  set doc(value: string) {
    this._doc = value;
  }

  set collection(value: string) {
    this._collection = value;
  }

  get doc() {
    return this._doc;
  }

  get collection() {
    return this._collection;
  }

  async getPostByDoc(): Promise<ISchedulePost> {
    return this.getDoc(this.collection, this.doc);
  }

  async getPosts(
    orderField: string = "created_at",
    orderDirection: firebase.firestore.OrderByDirection = "desc"
  ): Promise<Array<ISchedulePost>> {
    return this.get(this.collection, orderField, orderDirection);
  }

  async addPost(post: ISchedulePost): Promise<boolean> {
    return this.set(this.collection, this.doc, post);
  }

  async addPosts(posts: ISchedulePost[]): Promise<boolean[]> {
    const results: boolean[] = [];

    // Using Promise.all to perform parallel execution
    await Promise.all(
      posts.map(async (post) => {
        const result = await this.set(this.collection, this.doc, post);
        results.push(result);
      })
    );

    return results;
  }

  async deletePost(): Promise<boolean> {
    return this.delete(this.collection, this.doc);
  }
}
